import React from "react";
// Import User Provider
import { UserProvider } from "./User.context";
import { ModalProvider } from "./Modal.provider";
import AppAntdTranslationProvider from "./AppAntdTranslationProvider";

// Import i18n translations
import { I18nextProvider, initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import i18n from "i18next";
import i18nextOptions from "engine/i18nextOptions";

i18n
  .use(initReactI18next)
  .init(i18nextOptions);

function AppProviders({ children }) {
  return (
    <I18nextProvider i18n={i18n}>
      <AppAntdTranslationProvider>
        <UserProvider>
          <ModalProvider>{children}</ModalProvider>
        </UserProvider>
      </AppAntdTranslationProvider>
    </I18nextProvider>
  );
}

export { AppProviders, i18n };
export default AppProviders;
